module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 6);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = require("@xo-union/event-target-shim");

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = require("customevent");

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime-corejs3/core-js/promise");

/***/ }),
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "PageletContainer", function() { return /* reexport */ PageletContainer_PageletContainer; });
__webpack_require__.d(__webpack_exports__, "RemotePagelet", function() { return /* reexport */ RemotePagelet_RemotePagelet; });

// EXTERNAL MODULE: external "@xo-union/event-target-shim"
var event_target_shim_ = __webpack_require__(0);

// CONCATENATED MODULE: ./src/core/PageletContainer/CustomEvent.js
// eslint-disable-next-line func-style, prefer-arrow/prefer-arrow-functions
function CustomEvent() {
  // Defer requiring customevent to avoid runtime issue in nodejs
  // eslint-disable-next-line global-require
  const Constructor = __webpack_require__(1);

  for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
    params[_key] = arguments[_key];
  }

  return new Constructor(...params);
}

/* harmony default export */ var PageletContainer_CustomEvent = (CustomEvent);
// CONCATENATED MODULE: ./src/core/PageletContainer/createContainerContext/index.js
const createContainerContext = pageletContainer => ({
  // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
  get mountNode() {
    return pageletContainer.mountNode;
  },

  // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
  get props() {
    return pageletContainer.props;
  },

  addEventListener: function () {
    pageletContainer.addEventListener(...arguments);
  },
  removeEventListener: function () {
    pageletContainer.removeEventListener(...arguments);
  },
  pageletDidRender: () => {
    pageletContainer.mountNode.setAttribute('data-pagelet-render-state', 'ready');
  },
  pageletDidUnrender: () => {
    pageletContainer.mountNode.removeAttribute('data-pagelet-render-state');
  }
});

/* harmony default export */ var PageletContainer_createContainerContext = (createContainerContext);
// CONCATENATED MODULE: ./src/core/PageletContainer/index.js


 // Simple prepend ponyfill

const prepend = (parent, child) => {
  if (typeof parent.prepend === 'function') {
    parent.prepend(child);
    return;
  }

  parent.insertBefore(child, parent.firstChild);
};

const isRendered = pageletContainer => pageletContainer.mountNode.getAttribute('data-pagelet-render-state') === 'ready';

const emitErrorEvent = (pageletContainer, _ref) => {
  let {
    cancelable,
    detail
  } = _ref;
  const errorEvent = new PageletContainer_CustomEvent('error', {
    cancelable,
    detail: {
      isRendered: isRendered(pageletContainer),
      ...detail
    }
  });
  return pageletContainer.dispatchEvent(errorEvent);
};

const evaluatePageletScript = (scriptElement, containerContext) => {
  /* eslint-disable no-new-func */
  const source = scriptElement.innerHTML;
  const exec = new Function('pageletContainer', `'use strict';${source}`);
  exec.call({}, containerContext);
};

class PageletContainer_PageletContainer extends event_target_shim_["EventTarget"] {
  constructor(id) {
    let {
      errorPagelet,
      props
    } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    super();
    this.id = id;
    this.errorPagelet = errorPagelet;
    this.props = props;
    this.mountNode = null;
    this.willMount = null;
    this.currentPagelet = null;
    this.wasPrepared = false;
    /**
     * Data passed to children
     */

    this.containerContext = PageletContainer_createContainerContext(this);
  }

  prepare() {
    if (this.wasPrepared) {
      return;
    }

    const rootNode = document.body.querySelector(`[data-pagelet-container-id="${this.id}"]`);
    const pageletScriptElement = rootNode.querySelector('script[type="text/x-union-pagelet-script"]');
    let mountNode = rootNode.querySelector('[data-pagelet-role="mount-root"]');

    if (!mountNode) {
      mountNode = document.createElement('div');
      mountNode.setAttribute('data-pagelet-role', 'mount-root');
      prepend(rootNode, mountNode);
    }

    if (pageletScriptElement) {
      evaluatePageletScript(pageletScriptElement, this.containerContext);
    }

    this.mountNode = mountNode;
    this.wasPrepared = true;
  }

  mount(pagelet) {
    if (!this.wasPrepared) {
      this.prepare();
    }

    this.willMount = pagelet;
    this.dispatchEvent(new PageletContainer_CustomEvent('will-load', {
      detail: {
        pagelet
      }
    }));
    pagelet.load().then(() => {
      /**
       * Cancel mounting if unmount was called or if mount was called consecutively with different pagelets
       */
      if (this.willMount !== pagelet) {
        return;
      }

      this.currentPagelet = pagelet;
      pagelet.mount(this.containerContext);
      this.willMount = null;
    }, error => {
      // eslint-disable-next-line no-console
      console.error(error);
      const notCanceled = emitErrorEvent(this, {
        cancelable: true,
        detail: {
          phase: 'load',
          error
        }
      });

      if (notCanceled) {
        this.errorPagelet.mount(this.containerContext);
      }
    });
  }

  unmount() {
    this.willMount = null;

    if (!this.currentPagelet) {
      // eslint-disable-next-line no-console
      console.warn('Called PageletContainer#unmount with no mounted pagelet');
      return;
    }

    this.currentPagelet.unmount(this.containerContext);
    this.currentPagelet = null;
  }

  setProps(newProps) {
    const event = new PageletContainer_CustomEvent('props', {
      detail: {
        previousProps: this.props,
        props: newProps
      }
    });
    this.props = newProps;
    this.dispatchEvent(event);
  }

}
// EXTERNAL MODULE: external "@babel/runtime-corejs3/core-js/promise"
var promise_ = __webpack_require__(2);
var promise_default = /*#__PURE__*/__webpack_require__.n(promise_);

// CONCATENATED MODULE: ./src/core/RemotePagelet/loadLinks/index.js


const amdImport = dependencies => new promise_default.a((resolve, reject) => {
  const handleError = error => {
    reject(error);
  };

  const handleSuccess = function () {
    for (var _len = arguments.length, _exports = new Array(_len), _key = 0; _key < _len; _key++) {
      _exports[_key] = arguments[_key];
    }

    resolve(_exports);
  };

  window.UNION_INTERNAL_MODULE_SYSTEM.require(dependencies, handleSuccess, handleError);
});

/* harmony default export */ var loadLinks = (_ref => {
  let {
    links: {
      js,
      css
    } = {}
  } = _ref;
  const dependencies = [js.toString()];

  if (css) {
    dependencies.push(`css-loader!${css}`);
  }

  return amdImport(dependencies).then(_ref2 => {
    let [_exports] = _ref2;
    return _exports;
  });
});
// CONCATENATED MODULE: ./src/core/RemotePagelet/index.js

class RemotePagelet_RemotePagelet {
  constructor() {
    let {
      links = {},
      jsExportName = 'default'
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.pageletInstance = null;
    this.links = links;
    this.jsExportName = jsExportName;
  }

  get isLoaded() {
    return !!this.pageletInstance;
  }

  load() {
    return loadLinks({
      links: this.links
    }).then(exports => {
      this.pageletInstance = exports[this.jsExportName];
    });
  }

  mount(params) {
    return this.pageletInstance.mount(params);
  }

  unmount(params) {
    return this.pageletInstance.unmount(params);
  }

}
// CONCATENATED MODULE: ./src/core/index.js



/***/ })
/******/ ]);